import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { map } from 'rxjs';
import { CompanySiteService } from '../../services/company-site.service';

/**
 * Runs before every child route activation — and therefore before the route's
 * data resolvers — to honour deep links that carry an explicit company/site
 * context as `companyId` / `siteId` query params (e.g. the links baked into the
 * daily task report PDF).
 *
 * Back-end responses vary by the currently selected company and site, so when a
 * link targets a different context than the one currently active the switch must
 * complete before any data is fetched, otherwise the resolvers 404. When the
 * params are absent (a normal in-app navigation) or already match the active
 * context, the guard resolves immediately without contacting the back-end.
 */
export const ensureCompanySiteContextGuard: CanActivateChildFn = (route) => {
  const companySiteService = inject(CompanySiteService);

  const companyId = Number(route.queryParamMap.get('companyId'));
  const siteId = Number(route.queryParamMap.get('siteId'));

  if (!companyId || !siteId) {
    return true;
  }

  return companySiteService
    .switchToCompanySite(companyId, siteId)
    .pipe(map(() => true));
};
